import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.some.js";
import request from '@/utils/request';
import { baseUrl } from '@/common/settings';
import { ODATA } from '@/constant/common';
import { ElMessage } from 'element-plus';
// 获取更新后的供应商回标附件
export function getUpdateSupplierAttachment(header, ZcfaGuid) {
  if (header) {
    header.CsUsername = localStorage.getItem('CsUsername');
  } else {
    header = {
      CsUsername: localStorage.getItem('CsUsername')
    };
  }
  return request({
    // url: `${baseUrl}/ZFSRM_BIZTENDER_MAT_SRV/File2Set('0017FA0534DA1EEE8CA25E2AE4E0B200')/$value`,
    url: `${baseUrl}/ZFSRM_BIZTENDER_MAT_SRV/File2Set('${ZcfaGuid}')/$value`,
    method: 'get',
    headers: header,
    responseType: 'blob'
  });
}
// 调用 ODATA GET 带有filter
export function getDataRes(serviceId, entitySet, param, header) {
  if (header) {
    header.CsUsername = localStorage.getItem('CsUsername');
  } else {
    header = {
      CsUsername: localStorage.getItem('CsUsername')
    };
  }
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet + ODATA.FILTERS + param,
    method: 'get',
    headers: header
  });
}
export function getDetailDataRes(serviceId, entitySet, param, header) {
  if (header) {
    header.CsUsername = localStorage.getItem('CsUsername');
  } else {
    header = {
      CsUsername: localStorage.getItem('CsUsername')
    };
  }
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet + param,
    method: 'get',
    headers: header
  });
}
// 调用 ODATA GET 带有filter
export function getDataFilter(url, param, header) {
  if (header) {
    header.CsUsername = localStorage.getItem('CsUsername');
  } else {
    header = {
      CsUsername: localStorage.getItem('CsUsername')
    };
  }
  return request({
    url: baseUrl + url + ODATA.FILTERS + param,
    method: 'get',
    headers: header
  });
}
// 调用 ODATA GET 不携带filter参数
export function getDataNoFilter(serviceId, entitySet) {
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet,
    method: 'get',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
export function getDataNoFilterBlob(serviceId, entitySet) {
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet,
    method: 'get',
    responseType: 'blob',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用 ODATA GET 不携带filter参数
export function getDataUrl(url) {
  return request({
    url: baseUrl + url,
    method: 'get',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 获取metadata
export function getMetadata(uri) {
  return request({
    url: baseUrl + uri,
    method: 'get',
    headers: {
      responseType: 'xml'
    }
  });
}
// 调用Odata FunctionImport
export function postOdataFunction(serviceId, functionName, params) {
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + functionName + '?' + params,
    method: 'post',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用 ODATA POST
export function postData(serviceId, entitySet, data) {
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet,
    method: 'post',
    data,
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用 ODATA PUT
export function putData(serviceId, entitySet, guid, data) {
  return request({
    url: baseUrl + serviceId + ODATA.SEPARATOR + entitySet + guid,
    method: 'put',
    data,
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用 apikey post
export function postDataApikey(url, apikey, data) {
  return request({
    url: url,
    method: 'post',
    data,
    headers: {
      CsUsername: localStorage.getItem('CsUsername'),
      apikey: apikey
    }
  });
}
// 调用 附件 post
export function postAttachment(url, data) {
  return request({
    url: url,
    method: 'post',
    data,
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用  附件 get
export function getAttachment(url) {
  return request({
    url: url,
    method: 'get',
    responseType: 'blob',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 批量附件
export function batchAttachment(url, data) {
  return request({
    url: url,
    method: 'post',
    data,
    responseType: 'blob',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 删除附件
export function delAttachment(url) {
  return request({
    url: url,
    method: 'delete',
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
// 调用 ODATA POST [针对合同履约,作特殊处理]
export const postDataWithRetMsg = (serviceId, entitySet, data) => {
  return new Promise((resolve, reject) => {
    // 针对合同履约生成的CDS服务，统一添加返回消息结构
    data.RetMsgSet = [];
    postData(serviceId, entitySet, data).then(res => {
      const results = res?.d?.RetMsgSet?.results;
      if (results && Array.isArray(results)) {
        if (results.some(e => e.Type === 'E')) {
          const errorItems = results.filter(e => e.Type === 'E');
          ElMessage({
            message: errorItems?.[0]?.MessageText || '操作失败',
            type: 'error'
          });
          reject(errorItems);
        }
      }
      res.d.MessageSet = res.d.RetMsgSet;
      resolve(res);
    }).catch(err => {
      ElMessage({
        message: err?.message || '操作失败',
        type: 'error'
      });
      reject(err || '操作失败');
    });
  });
};
// 删除
export function del(url, data) {
  return request({
    url: url,
    method: 'delete',
    data,
    headers: {
      CsUsername: localStorage.getItem('CsUsername')
    }
  });
}
/**
 * 文件下载使用
 * @param url
 * @param header
 */
export function getFileData(url, header) {
  if (header) {
    header.CsUsername = localStorage.getItem('CsUsername');
  } else {
    header = {
      CsUsername: localStorage.getItem('CsUsername')
    };
  }
  return request({
    url: url,
    method: 'get',
    headers: header,
    responseType: 'blob'
  });
}
// 获取合同范本
export function getContractTemplateList(data) {
  return request({
    url: '/system/bgyOpen/contract/contract-template',
    method: 'post',
    data
  });
}
// 删除
export function uploadFile(url, data) {
  return request({
    url: url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
// 打印物料标签
export function printMaterialLabel(url) {
  return request({
    url: baseUrl + url,
    method: 'get'
  });
}
// 打印物料标签
export function printMaterialCheckState(url, data) {
  return request({
    url: baseUrl + url,
    method: 'post',
    data: data
  });
}